import { GET_LIKES, ADD_LIKE, DELETE_LIKE } from "../constants/actionTypes";

const initialState = {
    likes: [],
};

export const likeReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_LIKES:
            return {
                ...state,
                likes: {
                    ...state.likes,
                    [action.payload.postId]: action.payload.likes
                }
            };

        case ADD_LIKE:
            return {
                ...state,
                likes: {
                    ...state.likes,
                    [action.postId]: [
                        action.payload,
                        ...(state.likes[action.postId] || []),
                    ],
                },
            };

        case DELETE_LIKE:
            return {
                ...state,
                likes: state.likes.filter(
                    (like) => like.id !== action.payload.id // or use `like.userId` or `like.postId` depending on how you track likes
                ),
            };

        default:
            return state;
    }
};
